/**
 * Sends a form error event to the server-side log endpoint.
 * Fire-and-forget — never throws, never blocks form UX.
 *
 * @param {object} opts
 * @param {"contact"|"hire"} opts.form      - which form triggered the error
 * @param {string} opts.errorType           - bot_check | session_limit | cooldown | spam | submission_failed
 * @param {string} opts.message             - human-readable description
 * @param {string} [opts.email]             - raw email (masked server-side before writing)
 * @param {string} [opts.service]           - selected service option
 * @param {string} [opts.page]              - current pathname (falls back to window.location)
 */
export async function logFormError({ form, errorType, message, email = "", service = "", page }) {
    try {
        await fetch("/api/form-error-log", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                form,
                errorType,
                message,
                email,
                service,
                page: page ?? (typeof window !== "undefined" ? window.location.pathname : ""),
                userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
            }),
        });
    } catch {
        // intentionally silent — logging must never interrupt the user
    }
}